<template>
    <div class="bigDiv">
        <div class="h-crumbOut">
            <div class="h-crumbs">
                <el-breadcrumb separator="|">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">项目管理</a></el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">盈利测算</a></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="h-piece">
            <div class="h-pieceTitle2">
                <h1>项目信息</h1>
            </div>
            <div class="h-pieceCon2">
                <div class="h-formLine h-enters">
                    <el-form :model="ProMain" label-position="right" :rules="rules" ref="formLabelAlign" :inline="true"
                             class="demo-ruleForm h-formbLine">
                        <el-form-item label="项目名称" class="h-elformWrap-2">
                            <el-input v-model="ProMain.projectName" placeholder="自带出"></el-input>
                        </el-form-item>
                        <!-- todo  投标方式的类型选择具体的值是啥？？？如果是输入的话输入啥？？ -->
                        <el-form-item label="**投标方式" class="h-elformWrap-2">
                            <el-input v-model="ProMain.bidway" placeholder="请选择"></el-input>
                        </el-form-item>
                        <el-form-item label="开标日期" class="h-elformWrap-2">
                            <el-input v-model="ProMain.bid" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="选--保修期" class="h-elformWrap-2">
                            <el-select v-model="repairtype" placeholder="请选择" @change="repairchangetype">
                                <el-option v-for="item in repairOptions" :key="item.value"
                                           :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        
                        <el-form-item label="项目背景" class="h-elformWrap-2">
                            <el-input v-model="ProMain.projectDescription" placeholder="请输入"></el-input>
                        </el-form-item>
                        <!-- todo  终端成交价的类型选择具体的值是啥？？？ -->
                        <el-form-item label="**终端成交" class="h-elformWrap-2">
                            <el-input v-model="ProMain.zhongduanchengjiaojia" placeholder="请输入"
                                      style="width:200px;"></el-input>
                            <!--                            <el-select v-model="ProMain.zhongduanchengjiaojia" placeholder="请选择">-->
                            <!--                                <el-option label="类型一" value="type1"></el-option>-->
                            <!--                                <el-option label="类型二" value="type2"></el-option>-->
                            <!--                            </el-select>-->
                        </el-form-item>
                        <el-form-item label="专营商毛利率" class="h-elformWrap-2">
                            <el-input v-model="ProMain.zhuanyingshangmaolilv" placeholder="公式计算"></el-input>
                        </el-form-item>
						<el-form-item label="**付款方式" class="h-elformWrap-1 fukuan">
                            <el-input v-model="ProMain.pdpay" placeholder="请输入   预付百分比%(预付)"
                                      style="width:200px;"></el-input>
                            <el-input v-model="ProMain.fdpay" placeholder="请输入   %(首款)"
                                      style="width:200px;margin: 0 20px;"></el-input>
                            <el-input v-model="ProMain.mdpay" placeholder="请输入   %(中款)"
                                      style="width:200px;margin-right: 20px;"></el-input>
                            <el-input v-model="ProMain.ldpay" placeholder="请输入   %(尾款)" style="width:200px;"></el-input>
                        </el-form-item>
                        <br>
                        <el-form-item label="**账期" class="h-elformWrap-1">
                            <el-input v-model="ProMain.fdpayday" placeholder="请输入   首款天(预付)"
                                      style="width:200px;"></el-input>
                            <el-input v-model="ProMain.mdpayday" placeholder="请输入   中款天(预付)"
                                      style="width:200px;margin: 0 20px;"></el-input>
                            <el-input v-model="ProMain.ldpayday" placeholder="请输入   尾款天(预付)"
                                      style="width:200px;margin-right: 20px;"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div class="h-table">
            <el-table
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    @cell-dblclick="dblclick"
                    border
                    style="width: 100%; margin-top: 20px">
                <el-table-column
                        prop="message"
                        label="分类"
                        width="100"
						fixed
                >
                </el-table-column>
                <el-table-column
                        prop="coding"
						:show-overflow-tooltip="true"
                        label="科目"
						width="150"
                >
                </el-table-column>
                <el-table-column
                        prop="shuoming"
                        label="说明"
						:show-overflow-tooltip="true"
						width="150"
                >
                </el-table-column>
                <el-table-column
                        prop="biaozhun"
						width="150"
                        label="标准/单台">
                </el-table-column>
                <el-table-column
                        prop="hejiL"
						width="150"
                        label="合计-率">
                </el-table-column>
                <el-table-column
                        prop="hejiE"
						width="150"
                        label="合计-额">
                </el-table-column>
                <el-table-column
				 width="150"
                        :prop="item.prop"
                        :label="item.label" v-for="item in columndata" :key='item.label'>
						<template slot-scope="scope">
							<el-input v-if="scope.$index == 7 || scope.$index == 19 || scope.$index == 28"  v-model="scope.row[item.prop]" @focus="con(scope)"></el-input>
							<div v-else >{{scope.row[item.prop]}}</div>
							
						</template>
                </el-table-column>

                <!--            <el-table-column-->
                <!--                    prop="xiugai"-->
                <!--                    label="修改"-->
                <!--            >-->
                <!--                <template slot-scope="scope">-->
                <!--                    <div style="display:flex">-->
                <!--                        <el-select v-model="changeelse" placeholder="请选择" @change="elsechangetype">-->
                <!--                            <el-option v-for="item in changeelseOptions" :key="item.value"-->
                <!--                                       :label="item.label" :value="item.value">-->
                <!--                            </el-option>-->
                <!--                        </el-select>-->
                <!--                        <el-input v-model="scope.row.xiugai" placeholder="请输入"></el-input>-->
                <!--                        <el-button-->
                <!--                                type="text"-->
                <!--                                size="small"-->
                <!--                                class="h-tableLink"-->
                <!--                                @click="changetogo(scope.row.xiugai)">-->
                <!--                            修改-->
                <!--                        </el-button>-->
                <!--                    </div>-->
                <!--                </template>-->
                <!--            </el-table-column>-->

            </el-table>
        </div>
        <div class="drags" style="width:96.5%;padding:0 38px;margin-left:21px;margin-top:-20px;">
            <el-slider v-model="value3" :show-tooltip="true" :show-stops="true" @change="gotonextpage"></el-slider>
        </div>
        <div class="xia">
                <el-button class="h-btn h-bBtn h-bgwhite">返回</el-button>
                <el-button class="h-btn h-bBtn h-bggreen">暂存</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2 " @click="gotosubmitok">
                    确认提交
                </el-button>
        </div>
    </div>
</template>
<style scoped>
    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .product {
        margin-top: 10px;

    }

    .Ptitle {
        margin-top: 30px;
    }

    .resultA {
        border: 1px solid rgb(104, 184, 108);
        background-color: rgb(224, 233, 224);
        color: rgb(126, 216, 130);
    }

    .resultA, .resultB {
        width: 100%;
        height: 150px;
        border-radius: 4px;
        margin: 20px 0;
    }

    .resultB {
        border: 1px solid rgba(233, 161, 52, 0.925);
    }

    h6 > span {
        color: greenyellow;
    }

    h6 > .span {
        color: rgba(233, 161, 52, 0.925);
    }

    .xia {
		display: flex;
		justify-content: center;
		align-items: center;
        /* background-color: rgb(39, 122, 190); */
    }
</style>

<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {

            return {

                //中标服务费
                zhongbiaofuwufei: "123",

                //附加成本
                fujiachengben: "123",

                //申请单价含税
                shenqingdanjia: '123',

                //项目编号
                proid: "1",

                //质保选中值
                repairtype: '正常质保',

                repairOptions: [{
                    value: '正常质保',
                    label: '正常质保'
                }, {
                    value: '五年质保',
                    label: '五年质保'
                }],
				// 
				columndata:[
				],

                //列表翻页参数
                value3: 0,

                //上部列表信息
                ProMain: {

                    //项目名称
                    projectName: '',

                    //投标方式
                    bidway: '123',

                    //开标日期
                    bid: '',

                    //预付百分比
                    pdpay: '0.25',

                    //首款百分比
                    fdpay: '0.25',

                    //中款百分比
                    mdpay: '0.25',

                    //尾款百分比
                    ldpay: '0.25',

                    //首款天
                    fdpayday: '1',

                    //中款天
                    mdpayday: '1',

                    //尾款天
                    ldpayday: '1',

                    //项目描述
                    projectDescription: '',

                    //终端成交价
                    zhongduanchengjiaojia: '256',

                    //专营商毛利率
                    zhuanyingshangmaolilv: '123',

                },


                //当前表信息
                tableData: [],


                //所有查到的计算回调信息
                alllastlist: [],
				mydata:[],

            };
        },

        //加载页面默认执行
        created() {
            //默认首次交互
            this.getconfigs();
        },
mounted(){
	setTimeout(()=>{
		this.columndata.push({
							'prop':'xinghao',
							'label':'型号1'
						})
	},1000)
	this.mydata = [{
	    message: '基本信息',
	    coding: '编码',
	    shuoming: '-',
	    biaozhun: '-',
	    hejiL: '-',
	    hejiE: '-',
	
	}, {
	    coding: '型号',
	    biaozhun: '-',
	    shuoming: '-',
	    hejiL: '-',
	    hejiE: '-',
	
	}, {
	    coding: '产品大类',
	    biaozhun: '-',
	    shuoming: '-',
	    hejiL: '-',
	    hejiE: '-',
	
	}, {
	    coding: '产品系列',
	    biaozhun: '-',
	    shuoming: '-',
	    hejiL: '-',
	    hejiE: '-',
	
	}, {
	    message: '收入',
	    coding: '单台一级供价',
	    biaozhun: '-',
	    shuoming: '-',
	    hejiL: '-',
	    hejiE: '',
	
	}, {
	    coding: '折扣率',
	    biaozhun: '-',
	    shuoming: '-',
	    hejiL: '-',
	    hejiE: '-',
	},
	    {
	        coding: '销量',
	        biaozhun: '-',
	        shuoming: '-',
	        hejiL: '-',
	        hejiE: '',
	    },
	    {
	        coding: '申请单价(含税)',
	        biaozhun: '-',
	        shuoming: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '订单金额',
	        biaozhun: '-',
	        shuoming: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '不含税订单收入',
	        biaozhun: '-',
	        shuoming: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '盈亏平衡含税价',
	        biaozhun: '-',
	        shuoming: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        message: '盈利情况',
	        coding: '材料毛利',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '经营贡献',
	        biaozhun: '-',
	        shuoming: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '利润',
	        biaozhun: '-',
	        shuoming: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        message: '毛利',
	        coding: '单台成本',
	        shuoming: '测算当月BOM成本',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '成本合计',
	        biaozhun: '-',
	        shuoming: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '毛利',
	        biaozhun: '-',
	        shuoming: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '材料毛利率',
	        biaozhun: '-',
	        hejiL: '-',
	        shuoming: '-',
	        hejiE: '-',
	    },
	    {
	        message: '直接费用',
	        coding: '制造费用',
	        shuoming: '材料的制造费用率',
	        biaozhun: '-',
	        hejiL: '',
	        hejiE: '-',
	    },
		{
		    message: '直接费用',
		    coding: '附加成本',
		    shuoming: '赠送耗材、周转机等成本',
		    biaozhun: '-',
		    hejiL: '',
		    hejiE: '-',
		},
	    {
	        coding: '物流费用',
	        shuoming: '单位体积',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '运费',
	        shuoming: '260',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '安装费用',
	        shuoming: '单台安装费',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '安装费',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '维修费',
	        shuoming: '18年到产品实际费用',
	        biaozhun: '超低温:0.38%',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '备件费',
	        shuoming: '18年到产品实际费用',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '退换机',
	        shuoming: '18年到产品实际费用',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '资金成本',
	        shuoming: '资金成本损失',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '中标服务费',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    ,
	    {
	        coding: '税费',
	        shuoming: '维修基金',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '其他税费',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    ,
	    {
	        coding: '销售费用',
	        shuoming: '销售人工',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '销售组织运营',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '研发费用',
	        shuoming: '研发人工',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '研发组织运营',
	        shuoming: '超低温',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '直接费用小计',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        message: '经营贡献',
	        coding: '经营贡献',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	    },
	    {
	        coding: '经营贡献率',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	
	    },
	    {
	        message: '平台费用',
	        coding: '销售费用',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	
	    },
	    {
	        coding: '管理费用',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	
	    },
	    {
	        coding: '研发费用',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	
	    },
	    {
	        coding: '平台费用小计',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	
	    },
	    {
	        message: '利润',
	        coding: '利润',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	
	    },
	    {
	        coding: '利润率',
	        shuoming: '-',
	        biaozhun: '-',
	        hejiL: '-',
	        hejiE: '-',
	
	    }]
	console.log(this.mydata,"+++++++++++++++++++++++++++++++");
	var zanshi = this.mydata;
	var arr = [{prop:'xinghao',label:'型号1'},{prop:'xinghao2',label:'型号2'}]
	for(let j = 0;j<arr.length;j++){
		
		for(let i = 0;i<zanshi.length;i++){
			// zanshi[i].arr[j].prop
			console.log(arr[j].prop)
		}
	}
	
					
},

        methods: {
			con(i){
				console.log(i)
			},
			getit(){
				return 1
			},
            dblclick(v, h, c, d) {
                console.log(v, h, c, d)
            },
            arraySpanMethod({row, column, rowIndex, columnIndex}) {
                if (rowIndex % 3 === 0) {
                    if (columnIndex === 0) {
                        return [1, 4];
                    } else if (columnIndex === 1) {
                        return [0, 0];
                    }
                }
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (columnIndex === 0) {
                    if (rowIndex === 0) {
                        return {
                            rowspan: 4,
                            colspan: 1
                        };
                    } else if (rowIndex === 4) {  // 当第7行就为正常的一行；要返回 把1行合并为一列
                        return {
                            rowspan: 7,
                            colspan: 1
                        };
                    } else if (rowIndex === 11) {
                        return {
                            rowspan: 3,
                            colspan: 1
                        }
                    } else if (rowIndex === 14) {
                        return {
                            rowspan: 4,
                            colspan: 1
                        }
                    } else if (rowIndex === 18) {
                        return {
                            rowspan: 18,
                            colspan: 1
                        }
                    } else if (rowIndex === 36) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        }
                    } else if (rowIndex === 38) {
                        return {
                            rowspan: 4,
                            colspan: 1
                        }
                    } else if (rowIndex === 42) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        }
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        }
                    }
                }
                if (columnIndex === 1) {
                    if (rowIndex === 20) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    }else if(rowIndex === 21){
						return {
						    rowspan: 0,
						    colspan: 0
						};
					}
					else if (rowIndex === 22) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    }
					else if (rowIndex === 23) {
					    return {
					        rowspan: 0,
					        colspan: 0
					    };
					}
					 else if (rowIndex === 29) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } else if (rowIndex === 30) {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
					else if (rowIndex === 31) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    }
					 else if (rowIndex === 32) {
					     return {
					         rowspan: 0,
					         colspan: 0
					     };
					 }else if (rowIndex === 33) {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    } 
					else if (rowIndex === 34) {
					    return {
					        rowspan: 0,
					        colspan: 0
					    };
					} else {
                        return {
                            rowspan: 1,
                            colspan: 1
                        }
                    }
                }
                ;

            },






            rules: {
                name: [
                    {required: true, message: '请输入项目名称', trigger: 'blur'},
                ],
            },


            //保修期选择方法
            repairchangetype(value) {
                console.log(value);
                console.log(this.repairtype);
            },


            //前后台交互
            getconfigs() {

                //后台接口入参
                var inputto = {

                    // "proid": this.proid,
                    // "s17": this.shenqingdanjia,
                    // "s12": this.ProMain.zhongduanchengjiaojia,
                    // "f28": this.ProMain.pdpay,
                    // "f6": this.ProMain.fdpay,
                    // "f23": this.ProMain.fdpayday,
                    // "f27": this.ProMain.mdpay,
                    // "f13": this.ProMain.mdpayday,
                    // "f34": this.ProMain.ldpay,
                    // "f30": this.ProMain.ldpayday,
                    // "s14": this.fujiachengben,
                    // "s3": this.zhongbiaofuwufei,
                    // "bidway": this.ProMain.bidway,

                    "proid": "zckceshi",
                    "s17": "1500",
                    "s12": "2000",
                    "f28": "0.3",
                    "f6": "0.3",
                    "f23":"1",
                    "f27": "0.3",
                    "f13": "1",
                    "f34": "0.1",
                    "f30": "1",
                    "s14": "10",
                    "s3": "2",
                    "bidway": "zckceshi",


                };

                //调接口回调方法
                ss.FormulaNew.getAllRate(inputto).then(rd => {

                    //项目名称
                    this.ProMain.projectName = rd.result.projectName;
                    //开标时间
                    this.ProMain.bid = rd.result.bid;
                    //项目描述
                    this.ProMain.projectDescription = rd.result.projectDescription;
                    //专营商毛利率
                    this.ProMain.zhuanyingshangmaolilv = rd.result.zhuanyingshangmaolilv;

                    //下部列表所有计算查询返回信息
                    var listrd = rd.marnesList;

                    //单页数据
                    var csave = {};

                    //遍历每个产品的单表
                    for (var c in listrd) {

                        //单页数据
                        csave = {

                            //销量
                            "productNum": listrd[c].productNum == null ? "" : listrd[c].productNum,

                            //产品编码
                            "marcode": listrd[c].marcode == null ? "" : listrd[c].marcode,

                            //大类
                            "typeLevel": listrd[c].typeLevel == null ? "" : listrd[c].typeLevel,

                            //系列
                            "opeLevel": listrd[c].opeLevel == null ? "" : listrd[c].opeLevel,

                            //不知道是啥
                            "nonetypeLevel": listrd[c].nonetypeLevel == null ? "" : listrd[c].nonetypeLevel,

                            //产品型号
                            "productLevel": listrd[c].productLevel == null ? "" : listrd[c].productLevel,

                            //单台一级供价
                            "onemoney": listrd[c].onemoney == null ? "" : listrd[c].onemoney,

                            //专营商毛利率
                            "zhuanyingshangmaolilv": listrd[c].zhuanyingshangmaolilv == null ? "" : listrd[c].zhuanyingshangmaolilv,

                            //申请单价含税
                            "shenqingdanjia": listrd[c].shenqingdanjia == null ? "" : listrd[c].shenqingdanjia,

                            //折扣率
                            "zhekoulv": listrd[c].zhekoulv == null ? "" : listrd[c].zhekoulv,

                            //订单金额
                            "dingdanjine": listrd[c].dingdanjine == null ? "" : listrd[c].dingdanjine,

                            //不含税订单收入
                            "buhanshuishouru": listrd[c].buhanshuishouru == null ? "" : listrd[c].buhanshuishouru,

                            //单台成本
                            "dantaichengben": listrd[c].dantaichengben == null ? "" : listrd[c].dantaichengben,

                            //制造费用
                            "zhizaofeiyong": listrd[c].zhizaofeiyong == null ? "" : listrd[c].zhizaofeiyong,

                            //材料的制造费用率
                            "zhizaofeiyonglv": listrd[c].zhizaofeiyonglv == null ? "" : listrd[c].zhizaofeiyonglv,

                            //单台体积
                            "wuliufeiyongdanweitiji": listrd[c].wuliufeiyongdanweitiji == null ? "" : listrd[c].wuliufeiyongdanweitiji,

                            //单台安装费
                            "dantaianzhuangfei": listrd[c].dantaianzhuangfei == null ? "" : listrd[c].dantaianzhuangfei,

                            //维修基金
                            "weixiujijin": listrd[c].weixiujijin == null ? "" : listrd[c].weixiujijin,

                            //盈亏平衡含税价
                            "yingkuipingheng": listrd[c].yingkuipingheng == null ? "" : listrd[c].yingkuipingheng,

                            //材料毛利
                            "yinglicailiaomaoli": listrd[c].yinglicailiaomaoli == null ? "" : listrd[c].yinglicailiaomaoli,

                            //经营贡献
                            "jingyinggongxian": listrd[c].jingyinggongxian == null ? "" : listrd[c].jingyinggongxian,

                            //盈利 利润
                            "yinglilirun": listrd[c].yinglilirun == null ? "" : listrd[c].yinglilirun,

                            //毛利 成本合计
                            "maolichengbenheji": listrd[c].maolichengbenheji == null ? "" : listrd[c].maolichengbenheji,

                            //毛利 毛利
                            "maolimaoli": listrd[c].maolimaoli == null ? "" : listrd[c].maolimaoli,

                            //毛利 材料毛利率
                            "maolimaolilv": listrd[c].maolimaolilv == null ? "" : listrd[c].maolimaolilv,

                            //直接费用 物流费用 运费
                            "wuliufeiyongyunfei": listrd[c].wuliufeiyongyunfei == null ? "" : listrd[c].wuliufeiyongyunfei,

                            //直接费用 维修费  18年到产品实际费用
                            "zhijiefeiyongweixiufei": listrd[c].zhijiefeiyongweixiufei == null ? "" : listrd[c].zhijiefeiyongweixiufei,

                            //直接费用 备件费 18年到产品实际费用
                            "zhijiefeiyongbeijianfei": listrd[c].zhijiefeiyongbeijianfei == null ? "" : listrd[c].zhijiefeiyongbeijianfei,

                            //直接费用 退换机 18年到产品实际费用
                            "zhijiefeiyongtuihuanjifei": listrd[c].zhijiefeiyongtuihuanjifei == null ? "" : listrd[c].zhijiefeiyongtuihuanjifei,

                            //直接费用 退换机 18年到产品实际费用
                            "zijinchengben": listrd[c].zijinchengben == null ? "" : listrd[c].zijinchengben,

                            //中标服务费
                            "zhongbiaofuwufei": listrd[c].zhongbiaofuwufei == null ? "" : listrd[c].zhongbiaofuwufei,

                            //直接费用 税费 其他税费
                            "shuifeiqitashuifei": listrd[c].shuifeiqitashuifei == null ? "" : listrd[c].shuifeiqitashuifei,

                            //销售费用 销售人工
                            "xiaoshoufeiyongrengong": listrd[c].xiaoshoufeiyongrengong == null ? "" : listrd[c].xiaoshoufeiyongrengong,

                            //销售费用 销售组织运营
                            "xiaoshouzuzhiyunying": listrd[c].xiaoshouzuzhiyunying == null ? "" : listrd[c].xiaoshouzuzhiyunying,

                            //研发费用 研发人工
                            "yanfarengong": listrd[c].yanfarengong == null ? "" : listrd[c].yanfarengong,


                            //研发费用 研发组织运营
                            "yanfayunying": listrd[c].yanfayunying == null ? "" : listrd[c].yanfayunying,

                            //直接费用小计
                            "zhijiefeiyongxiaoji": listrd[c].zhijiefeiyongxiaoji == null ? "" : listrd[c].zhijiefeiyongxiaoji,

                            //经营贡献 经营贡献 经营贡献
                            "jingyinggongxiansan": listrd[c].jingyinggongxiansan == null ? "" : listrd[c].jingyinggongxiansan,

                            //经营贡献 经营贡献率 经营贡献率
                            "jingyinggongxianlv": listrd[c].jingyinggongxianlv == null ? "" : listrd[c].jingyinggongxianlv,

                            //平台费用 销售费用 自产费用率
                            "pingtaixiaoshoufeiyong": listrd[c].pingtaixiaoshoufeiyong == null ? "" : listrd[c].pingtaixiaoshoufeiyong,

                            //平台费用 管理费用 全部产品费用率
                            "pingtaiguanlifeiyong": listrd[c].pingtaiguanlifeiyong == null ? "" : listrd[c].pingtaiguanlifeiyong,

                            //平台费用 研发费用 自产研发费
                            "pingtaiyanfafeiyong": listrd[c].pingtaiyanfafeiyong == null ? "" : listrd[c].pingtaiyanfafeiyong,

                            //平台费用 平台费用小计
                            "pingtaifeiyongxiaoji": listrd[c].pingtaifeiyongxiaoji == null ? "" : listrd[c].pingtaifeiyongxiaoji,

                            //利润 利润  利润
                            "lirunsan": listrd[c].lirunsan == null ? "" : listrd[c].lirunsan,

                            //利润 利润率  利润率
                            "lirunlirunlv": listrd[c].lirunlirunlv == null ? "" : listrd[c].lirunlirunlv,






                        }


                        this.alllastlist.push(csave);


                        //显示第一页
                        if (c == 0) {

                            this.ProMain.zhuanyingshangmaolilv = csave.zhuanyingshangmaolilv;

                            this.tableData = [{
                                message: '基本信息',
                                coding: '编码',
                                shuoming: '-',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '-',
                                xinghao: csave.marcode,

                            }, {
                                coding: '型号',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '-',
                                xinghao: csave.productLevel,

                            }, {
                                coding: '产品大类',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '-',
                                xinghao: csave.typeLevel,

                            }, {
                                coding: '产品系列',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '-',
                                xinghao: csave.opeLevel,

                            }, {
                                message: '收入',
                                coding: '单台一级供价',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: csave.onemoney,
                                xinghao: csave.onemoney,

                            }, {
                                coding: '折扣率',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '-',
                                xinghao: csave.zhekoulv,
                            },
                                {
                                    coding: '销量',
                                    biaozhun: '-',
                                    shuoming: '-',
                                    hejiL: '-',
                                    hejiE: csave.productNum,
                                    xinghao: csave.productNum,
                                },
                                {
                                    coding: '申请单价(含税)',
                                    biaozhun: '-',
                                    shuoming: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.shenqingdanjia,
                                },
                                {
                                    coding: '订单金额',
                                    biaozhun: '-',
                                    shuoming: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.dingdanjine,
                                },
                                {
                                    coding: '不含税订单收入',
                                    biaozhun: '-',
                                    shuoming: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.buhanshuishouru,
                                },
                                {
                                    coding: '盈亏平衡含税价',
                                    biaozhun: '-',
                                    shuoming: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.yingkuipingheng,
                                },
                                {
                                    message: '盈利情况',
                                    coding: '材料毛利',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.yinglicailiaomaoli,
                                },
                                {
                                    coding: '经营贡献',
                                    biaozhun: '-',
                                    shuoming: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.jingyinggongxian,
                                },
                                {
                                    coding: '利润',
                                    biaozhun: '-',
                                    shuoming: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.yinglilirun,
                                },
                                {
                                    message: '毛利',
                                    coding: '单台成本',
                                    shuoming: '测算当月BOM成本',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.dantaichengben,
                                },
                                {
                                    coding: '成本合计',
                                    biaozhun: '-',
                                    shuoming: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.maolichengbenheji,
                                },
                                {
                                    coding: '毛利',
                                    biaozhun: '-',
                                    shuoming: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.maolimaoli,
                                },
                                {
                                    coding: '材料毛利率',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    shuoming: '-',
                                    hejiE: '-',
                                    xinghao: csave.maolimaolilv,
                                },
                                {
                                    message: '直接费用',
                                    coding: '制造费用',
                                    shuoming: '材料的制造费用率',
                                    biaozhun: '-',
                                    hejiL: csave.zhizaofeiyonglv,
                                    hejiE: '-',
                                    xinghao: csave.zhizaofeiyong,
                                },
								{
								    message: '直接费用',
								    coding: '附加成本',
								    shuoming: '赠送耗材、周转机等成本',
								    biaozhun: '-',
								    hejiL: csave.zhizaofeiyonglv,
								    hejiE: '-',
								    xinghao: csave.zhizaofeiyong,
								},
                                {
                                    coding: '物流费用',
                                    shuoming: '单位体积',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.wuliufeiyongdanweitiji,
                                },
                                {
                                    coding: '运费',
                                    shuoming: '260',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.wuliufeiyongyunfei,
                                },
                                {
                                    coding: '安装费用',
                                    shuoming: '单台安装费',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.dantaianzhuangfei,
                                },
                                {
                                    coding: '安装费',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.dantaianzhuangfei,
                                },
                                {
                                    coding: '维修费',
                                    shuoming: '18年到产品实际费用',
                                    biaozhun: '超低温:0.38%',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.zhijiefeiyongweixiufei,
                                },
                                {
                                    coding: '备件费',
                                    shuoming: '18年到产品实际费用',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.zhijiefeiyongbeijianfei,
                                },
                                {
                                    coding: '退换机',
                                    shuoming: '18年到产品实际费用',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.zhijiefeiyongtuihuanjifei,
                                },
                                {
                                    coding: '资金成本',
                                    shuoming: '资金成本损失',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.zijinchengben,
                                },
                                {
                                    coding: '中标服务费',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.zhongbiaofuwufei,
                                },
                                ,
                                {
                                    coding: '税费',
                                    shuoming: '维修基金',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.weixiujijin,
                                },
                                {
                                    coding: '其他税费',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.shuifeiqitashuifei,
                                },
                                ,
                                {
                                    coding: '销售费用',
                                    shuoming: '销售人工',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.xiaoshoufeiyongrengong,
                                },
                                {
                                    coding: '销售组织运营',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.xiaoshouzuzhiyunying,
                                },
                                {
                                    coding: '研发费用',
                                    shuoming: '研发人工',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.yanfarengong,
                                },
                                {
                                    coding: '研发组织运营',
                                    shuoming: '超低温',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.yanfayunying,
                                },
                                {
                                    coding: '直接费用小计',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.zhijiefeiyongxiaoji,
                                },
                                {
                                    message: '经营贡献',
                                    coding: '经营贡献',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.jingyinggongxiansan,
                                },
                                {
                                    coding: '经营贡献率',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.jingyinggongxianlv,

                                },
                                {
                                    message: '平台费用',
                                    coding: '销售费用',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.pingtaixiaoshoufeiyong,

                                },
                                {
                                    coding: '管理费用',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.pingtaiguanlifeiyong,

                                },
                                {
                                    coding: '研发费用',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.pingtaiyanfafeiyong,

                                },
                                {
                                    coding: '平台费用小计',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.pingtaifeiyongxiaoji,

                                },
                                {
                                    message: '利润',
                                    coding: '利润',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.lirunsan,

                                },
                                {
                                    coding: '利润率',
                                    shuoming: '-',
                                    biaozhun: '-',
                                    hejiL: '-',
                                    hejiE: '-',
                                    xinghao: csave.lirunlirunlv,

                                },]

                        }


                    }


                });


            },


            //翻页
            gotonextpage() {

                for (var j in this.alllastlist) {

                    if (this.alllastlist.length >= this.value3 && this.value3 == j) {

                        //   替换数据

                        this.ProMain.zhuanyingshangmaolilv = this.alllastlist[j].zhuanyingshangmaolilv;


                        this.tableData = [{
                            message: '基本信息',
                            coding: '编码',
                            shuoming: '-',
                            biaozhun: '-',
                            hejiL: '-',
                            hejiE: '-',
                            xinghao: this.alllastlist[j].marcode,
                            xiugai: '-',
                        }, {
                            coding: '型号',
                            biaozhun: '-',
                            shuoming: '-',
                            hejiL: '-',
                            hejiE: '-',
                            xinghao: this.alllastlist[j].productLevel,
                            xiugai: '-',
                        }, {
                            coding: '产品大类',
                            biaozhun: '-',
                            shuoming: '-',
                            hejiL: '-',
                            hejiE: '-',
                            xinghao: this.alllastlist[j].typeLevel,
                            xiugai: '-',
                        }, {
                            coding: '产品系列',
                            biaozhun: '-',
                            shuoming: '-',
                            hejiL: '-',
                            hejiE: '-',
                            xinghao: this.alllastlist[j].opeLevel,
                            xiugai: '-',
                        }, {
                            message: '收入',
                            coding: '单台一级供价',
                            biaozhun: '-',
                            shuoming: '-',
                            hejiL: '-',
                            hejiE: this.alllastlist[j].onemoney,
                            xinghao: this.alllastlist[j].onemoney,
                            xiugai: '-',
                        }, {
                            coding: '折扣率',
                            biaozhun: '-',
                            shuoming: '-',
                            hejiL: '51%',
                            hejiE: '51%',
                            xinghao: '51%',
                            xiugai: '-',
                        },
                            {
                                coding: '销量',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: this.alllastlist[j].productNum,
                                xinghao: this.alllastlist[j].productNum,

                            },
                            {
                                coding: '申请单价(含税)',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '26,000',
                                xinghao: '26,000',

                            },
                            {
                                coding: '订单金额',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '130,000',
                                xinghao: '130,000',

                            },
                            {
                                coding: '不含税订单收入',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '盈亏平衡含税价',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                message: '盈利情况',
                                coding: '材料毛利',
                                shuoming: '-',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '经营贡献',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '利润',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                message: '毛利',
                                coding: '单台成本',
                                shuoming: '测算当月BOM成本',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '成本合计',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '毛利',
                                biaozhun: '-',
                                shuoming: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '材料毛利率',
                                biaozhun: '-',
                                hejiL: '-',
                                shuoming: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                message: '直接费用',
                                coding: '制造费用',
                                shuoming: '材料的制造费用率',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '物流费用',
                                shuoming: '单位体积',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '运费',
                                shuoming: '260',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '安装费用',
                                shuoming: '单台安装费',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '安装费',
                                shuoming: '-',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '维修费',
                                shuoming: '18年到产品实际费用',
                                biaozhun: '超低温:0.38%',
                                hejiL: '0.38',
                                hejiE: '437',
                                xinghao: '427',

                            },
                            {
                                coding: '备件费',
                                shuoming: '18年到产品实际费用',
                                biaozhun: '超低温:0.38%-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '退换机',
                                shuoming: '18年到产品实际费用',
                                biaozhun: '超低温:0.38%',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '资金成本',
                                shuoming: '资金成本损失',
                                biaozhun: '年度6个点,月度0.5%',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '中标服务费',
                                shuoming: '-',
                                biaozhun: '-',
                                hejiL: '0.0%',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '税费',
                                shuoming: '维修基金',
                                biaozhun: '12',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '其他税费',
                                shuoming: '0.98%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '销售费用',
                                shuoming: '销售人工',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '销售组织运营',
                                shuoming: '0.36%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '研发费用',
                                shuoming: '研发人工',
                                biaozhun: '超低温',
                                hejiL: '1.12%',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '研发组织运营',
                                shuoming: '超低温',
                                biaozhun: '0.35%',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '直接费用小计',
                                shuoming: '-',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                message: '经营贡献',
                                coding: '经营贡献',
                                shuoming: '0.36%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '经营贡献率',
                                shuoming: '0.36%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                message: '平台费用',
                                coding: '销售费用',
                                shuoming: '0.36%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '管理费用',
                                shuoming: '0.36%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '研发费用',
                                shuoming: '0.36%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '平台费用小计',
                                shuoming: '0.36%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                message: '利润',
                                coding: '利润',
                                shuoming: '0.36%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },
                            {
                                coding: '利润率',
                                shuoming: '0.36%',
                                biaozhun: '-',
                                hejiL: '-',
                                hejiE: '115.044',
                                xinghao: '115.044',

                            },]


                    }

                }


            },


            //提交页面跳转方法
            gotosubmitok() {

                var inputto = {

                    "toubiaofangshi": this.formLabelAlign.toubiaofangshi

                };


            }


        }
    }

</script>
<style scoped>
    .h-piece, .h-table {
        margin: 20px;
    }


    .xingxing {
        position: absolute;
        top: 0;
        left: -89px;
        color: red;
        font-size: 0.2rem;
    }

    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }

    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
        background-color: rgb(118, 201, 118);
    }

    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }

    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }

    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }

    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }

    .tip {
        margin-left: 1.6rem;
        color: #b0b0b0;
        font-size: 0.2rem;
        margin-top: 10px;
    }

    .h-bgccc {
        background: #edf5fa;
        border-color: #959595;
        color: #92999e;
    }

    .drags {
        background-color: #ffffff;
        margin-bottom: 30px;
    }
</style>
<style>
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }

    .selectorBox .el-upload-list {
        display: none;
    }
	.h-enters .h-formbLine .h-elformWrap-2{
	    width: 33.333%;
	}
	.h-enters .h-formbLine .el-form-item__label{
	    width: 43%;
	}
	.h-enters .h-formbLine .h-elformWrap-1 .el-form-item__label{
		width: 12%;
	}
	.h-enters .h-formbLine .h-elformWrap-1 .el-form-item__content{
		width: 88%;
	}
	.h-enters .h-formbLine .el-form-item__content{
	    width:57%;
	}


/*    .drags .el-slider__button-wrapper .el-slider__button {
        background: url(../../../assets/images/drag.png) center/cover;
        border: 0;
        border-radius: 0;
        width: 20px;
        height: 20px;
    } */
</style>




